import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { GOOGLE_WORD_LOGO_IMAGE } from '@shared/constants/hostedImages';

export const PoweredByGoogle: React.FC = () => {
  return (
    <Flex
      justifyContent={'flex-end'}
      padding={3}
    >
      {/* Not translated — must remain in English per Google branding guidelines */}
      <TextV2 typographyVariant={'label1'}>Powered by</TextV2>
      <Flex __css={{ '& > img': { paddingBottom: '3px' } }}>
        <img
          src={GOOGLE_WORD_LOGO_IMAGE}
          alt="Google"
          width={60}
          height={19}
        />
      </Flex>
    </Flex>
  );
};
